import { render, staticRenderFns } from "./UserGoldList.vue?vue&type=template&id=1dbf9fd2&scoped=true"
import script from "./UserGoldList.vue?vue&type=script&lang=js"
export * from "./UserGoldList.vue?vue&type=script&lang=js"
import style0 from "./UserGoldList.vue?vue&type=style&index=0&id=1dbf9fd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbf9fd2",
  null
  
)

export default component.exports